import React, { createContext, useContext, useEffect, useState } from "react";

const SystemContext = createContext(null);

export function SystemProvider({ children }) {
  const [system, setSystemRaw] = useState(() => localStorage.getItem("tara_system") || "");

  const setSystem = (s) => {
    if (s) localStorage.setItem("tara_system", s);
    else localStorage.removeItem("tara_system");
    setSystemRaw(s || "");
  };

  return (
    <SystemContext.Provider value={{ system, setSystem }}>
      {children}
    </SystemContext.Provider>
  );
}

export const useSystem = () => useContext(SystemContext);

export const SYSTEM_META = {
  SATURNUS: { label: "Saturnuspay", color: "info", short: "STPAY" },
  TARAPAY: { label: "Tarapay", color: "awaiting", short: "TARA" },
};

export const SERVICE_META = {
  PAYIN: { label: "Pay-In", color: "info", short: "IN" },
  PAYOUT: { label: "Payout", color: "awaiting", short: "OUT" },
  WITHDRAWAL: { label: "Withdrawal", color: "warning", short: "WD" },
  TOPUP: { label: "Top-Up", color: "success", short: "TU" },
};
